/**
 * 밖으로 나가는 주소를 한곳에 모은다.
 *
 * 원래 Navbar가 가리키던 Notion의 서명된 임시 URL은 2025-02-17에 만료돼 이미
 * 깨져 있었다. 영구 식별자(DOI)만 쓰고, 여러 파일에 흩어 두지 않는다.
 */
export const PAPER_DOI = 'https://doi.org/10.3390/app16052314';
export const CORE_REPO = 'https://github.com/Coldlapse/PixelZoom';
export const TEAM_ORG = 'https://github.com/PixelZoom-Team';
export const SUPPORT_URL = 'https://buymeacoffee.com/sadang';
export const HRI_LAB = 'https://hri.dongguk.edu/';
